import $ from 'jquery';

window.$ = window.$ = $;

import 'magnific-popup';
import '../../vendor/superfish.js';
import 'hamburgers';
import 'jquery-validation';
import SendAjax from "./SendAjax.js";

//Load Data for Load more pagination (for POST method)
const loadData = {
	paged : 0,
	current_cat : 0,
	search : ''
};

//Max page count for load more
// let pageCount = 0;

//Img placeholder

const NO_IMG = `${ window.location.origin }/wp-content/themes/mauriziolacava/assets/img/no-img.svg`;

//TEMPLATES

$( document ).ready( function(){

	if( $( "body" ).hasClass( "addin-page-body" ) ){
		//lazySizes.loader.unveil($('.lazyload'));
		$( "img.lazyload" ).each( function(){
			let path = $( this ).data( "src" );
			$( this ).attr( "src", path );
		} );
	}

	$( ".mlc-assets-platform a" ).on( "click", function( e ){
		e.preventDefault();
	} );

	$( ".but_talk_to_us" ).click( function( event ){
		event.preventDefault();
		$( "#mlc-contact-form" ).addClass( "visible" );
	} );

	$("._form").each(function() {
    	$(this).validate({  
			rules : {
				email : {
					required : true,
					email : true,
				},
			},
			errorPlacement : function( error, element ){
				if( element.data( "name" ) === "privacy_acceptance" ){
					error.appendTo( element.parent() );
				} else {
					error.insertAfter( element );
				}
			},
		} )
	} );

	mobileFastLinks();
	$( window ).on( "resize", function(){
		mobileFastLinks();
	} );

	$( ".navbar-nav" ).superfish( {
		popUpSelector : "div,.sf-mega",
		animation : { opacity : "show", marginTop : "0" },
		animationOut : { opacity : "hide", marginTop : "-5px" },
		delay : 500,
		speed : "fast",
		speedOut : "fast",
	} );

	$( ".nav-link.dropdown-toggle" ).on( "click", function( e ){
		e.preventDefault();
	} );

	$( ".mlc-lightbox" ).on( "click", function(){
		let imageUrl = $( this ).find( "img" ).attr( "src" );
		$.magnificPopup.open(
			{
				items : {
					src : imageUrl,
				},
				type : "image",
			},
			0
		);
	} );

	$( ".mlc-inline-popup > a" ).magnificPopup( {
		type : "inline",
		midClick : true,
	} );

	$( ".gallery-zoom-item" ).magnificPopup( {
		type : "image",
		image : {
			verticalFit : true,
		},
		preload : [1, 3],
		gallery : {
			enabled : true,
		},
		mainClass : "mfp-fade",
	} );

	$( ".navbar-toggler" ).on( "click", function(){
		let navigation = $( this ).data( "target" );
		$( this ).toggleClass( "is-active" );
		$( navigation ).slideToggle( 300 );
		$( ".mobile-fast-links" ).slideToggle( 300 );
		$( ".dropdown-menu" ).slideUp( 200 );
	} );

	$( window ).on( "scroll", function(){
		let bottomPage = $( window ).scrollTop() === $( document ).height() - $( window ).height();
		let y = $( this ).scrollTop();
		if( y > 100 ){
			$( "#mlc-contact-widget, .ssbp-wrap" ).addClass( "visible" );
		} else {
			$( "#mlc-contact-widget, .ssbp-wrap" ).removeClass( "visible" );
		}
		if( y > 1600 || bottomPage ){
			$( "#scroll-to-top" ).addClass( "visible" );
		} else {
			$( "#scroll-to-top" ).removeClass( "visible" );
		}
	} );

	$( ".scroll-to" ).on( "click", function( e ){
		e.preventDefault();
		let target = $( this ).data( "target" );
		$( "html, body" ).animate(
			{
				scrollTop : $( target ).offset().top,
			},
			800
		);
	} );

	$( "#mlc-contact-widget .media, .speaker-invite" ).on( "click", function( e ){
		e.preventDefault();
		$( "#mlc-contact-form" ).addClass( "visible" );
		if( $( window ).width() < 800 ){
			$( ".ssbp-wrap" ).fadeOut( 100 );
		}
	} );

	$( "#mlc-contact-form-close" ).on( "click", function(){
		$( "#mlc-contact-form" ).removeClass( "visible" );
		if( $( window ).width() < 800 ){
			$( ".ssbp-wrap" ).fadeIn( 100 );
		}
	} );

	$( "#spread-ideas-home h2, .homepage-heroshot .btn" ).on( "hover", function(){
		$( this ).toggleClass( "active" );
	} ).on( "click", function( e ){
		e.preventDefault();
		$( "html, body" ).animate(
			{
				scrollTop : $( ".mlc-slide-1" ).offset().top - 50,
			},
			300
		);
	} );


	$("#billing_company_field, #billing_vat_number_field, #billing_codice_fiscale_field")
		.addClass( "validate-required" )
		.find( "label" )
		.append( '<abbr class="required" title="required">*</abbr>' )
		.find( ".optional" )
		.remove();

	if( $( "#billing_check_private_field" ).length ){
		checkCustomerType();
		$( 'input[name="billing_check_private"], #billing_country' ).on(
			"change",
			function(){
				checkCustomerType();
			}
		);
	}

	//Analytics
	$( '.apply_to_join button[type="submit"]' ).click( function(){
		dataLayer.push( {
			event : "ga_goals",
			category : "Submit",
			action : "elpd_launch_subscription",
			label : "eLPD Launch subscription",
		} );
	} );

	$( ".our_corporate_home a" ).click( function(){
		dataLayer.push( {
			event : "ga_goals",
			category : "Click",
			action : "corporate_pres_home",
			label : "Corporate pres home",
		} );
	} );

	$( ".our_corporate a" ).click( function(){
		dataLayer.push( {
			event : "ga_goals",
			category : "Click",
			action : "corporate_pres_design",
			label : "Corporate pres design",
		} );
	} );

	$( '.training_pres button[type="submit"]' ).submit( function(){
		dataLayer.push( {
			event : "ga_goals",
			category : "Click",
			action : "training_pres",
			label : "Training pres",
		} );
	} );

	$( ".mlc-contact-form form" ).submit( function(){
		let type = $( '.looking_for input[type="radio"]:checked' ).val();
		type = type.toLocaleLowerCase();
		let data = {
			event : "ga_goals",
			category : "Submit",
		};

		switch( type ){
			case "design":
				data.action = "talk_to_us_design";
				data.label = "Talk to us Design";
				break;
			case "training":
				data.action = "talk_to_us_training";
				data.label = "Talk to us Training";
				break;
			case "add-in":
				data.action = "talk_to_us_add_in";
				data.label = "Talk to us Add-in";
				break;
			case "other":
				data.action = "talk_to_us_other";
				data.label = "Talk to us Other";
				break;
		}
		dataLayer.push( data );
	} );

	$( ".logout" ).click( function(){
		$( this ).toggleClass( "open" );
		$( this ).find( "ul" ).toggle();
	} );

	$( ".logout ul" ).mouseleave( function(){
		$( this ).closest( ".logout" ).toggleClass( "open" );
		$( this ).hide();
	} );

	//Add new Vector icons
	$( ".load-more-btn" ).on( "click", loadMoreHandler() );

	$( document ).on( 'click', '.download', function( event ){
		event.preventDefault();

		let btn = $( this );
		let ajax_obj = new SendAjax( btn, "mlc_assets", 'template' );

		ajax_obj.prepareSendData( {
			id : $( this ).data( 'id' )
		} );

		ajax_obj.beforeSend = () => {
			btn.prop( "disabled", true );
		};
		ajax_obj.successSend = ( response ) => {
			if( response.file ){
				window.location.href = window.location.origin + '/wp-content/themes/mauriziolacava/download.php?ppt=' + response.file;
			}
		};
		ajax_obj.complete = () => {
			btn.prop( "disabled", false );
		};

		ajax_obj.send();
	} );

} );

ACForm();

function ACForm(){

	$('._form').ready( function(){

		let form = $( this );

		if( window.ac_language !== 'en' ){

			let fullName = form.find( '[data-name~="fullname"]' );
			if( $( fullName ).length ){
				$( fullName ).attr( "placeholder", eval( "window.ac_strings.fullname.placeholder" ) );
			}

			let email = form.find( '[data-name~="email"]' );
			if( $( email ).length ){
				$( email ).attr( "placeholder", eval( "window.ac_strings.email.placeholder" ) );
			}

			let companyName = form.find( '[data-name~="company_name"]' );
			if( $( companyName ).length ){
				$( companyName ).attr( "placeholder", eval( "window.ac_strings.company.placeholder" ) );
			}

			let privacyAcceptance = form.find('input[data-name~="privacy_acceptance"]');
			if( $( privacyAcceptance ).length ){
				$( 'input[data-name~="privacy_acceptance"][type="checkbox"]' ).parent().find( 'label' ).html( eval( "window.ac_strings.privacy_policy.label" ) );
			}

			let submit_label = form.find( "._submit" );
			if( $( submit_label ).length ){
				$( submit_label ).html( eval( "window.ac_strings.submit_label" ) );
			}

			let thankYou = form.find( "._form-thank-you" );
			if( $( thankYou ).length ){
				$( thankYou ).one( 'DOMSubtreeModified', function(){
					$( this ).html( eval( "json.thankyou_msg" ) );
				} );
			}

		}

		let language = form.find( '[data-name~="language"]' );
		if( $(language).length ){
			$( language ).val( window.ac_language );
		}

		let postId =  form.find( '[data-name~="post_id"]' );
		if( $( postId ).length ){
			$( postId ).val( window.ac_post_id );
		}
	});
}



let DownloadTemplates = {
	icons : ( data, isAuth = false ) => {
		let { Base64Data : image, Name : name } = data;
		if( image === undefined || image === "" ) image = NO_IMG;
		return `<div class="mlc-pt-card-container">
		<div class="mlc-pt-card">
			<img class="mlc-pt-card__img" src="${ image }" alt="${ name }">
			<div class="mlc-pt-card__substrate">
			${ isAuth
			? `<a href="${ image }" download="${ name }">
					<img src="${ window.location.origin }/wp-content/themes/mauriziolacava/assets/img/download.svg" alt="${ name }">
				</a>`
			: `<a href="${ window.location.origin }/my-account">
					<img src="${ window.location.origin }/wp-content/themes/mauriziolacava/assets/img/download.svg" alt="Download">
				</a>`
		}
			</div>
		</div>
	</div>`;
	},

	templates : ( data, isAuth ) => {
		let { Base64Data : image, Name : name, Id : id } = data;
		if( image === undefined || image === "" ) image = NO_IMG;

		return `<div class="mlc-pt-card-container">
		<div class="mlc-pt-card">
			<img class="mlc-pt-card__img" src="${ image }" alt="${ name }">
			<div class="mlc-pt-card__substrate">
				<p class="mlc-pt-card__title">${ name ? name : "Title" }</p>
				${
			isAuth
				? `<a href="/download" class="btn btn-yellow download" data-id="${ id }">Download</a>`
				: `<a href="${ window.location.origin }/my-account" class="btn btn-yellow">Download</a>`
		}
			</div>
		</div>
	</div>`;
	},
};

DownloadTemplates.flags = DownloadTemplates.icons;

function checkCustomerType(){
	let billingCustomerType = $(
		'input[name="billing_check_private"]:checked'
	).val();
	let billingCountry = $( "#billing_country" ).val();
	let billingInputsCompany = $(
		"#billing_company_field, #billing_vat_number_field"
	);
	//let billingInputsCompanyItaly = $('#billing_email_pec_field, #billing_codice_sdi_field');
	let billingInputsCompanyItaly = $( "#billing_codice_sdi_field" );
	let billingInputsPrivateItaly = $( "#billing_codice_fiscale_field" );

	if( billingCustomerType === "company" ){
		// billingInputsCompany.css("display", "block");
		billingInputsCompany.addClass( "form-input-visible" );
		billingInputsCompany.removeClass( "form-input-hidden" );

		if( billingCountry == "IT" ){
			// billingInputsCompanyItaly.css("display", "block");
			billingInputsCompanyItaly.addClass( "form-input-visible" );
			billingInputsCompanyItaly.removeClass( "form-input-hidden" );
		} else {
			// billingInputsCompanyItaly.css("display", "none");
			billingInputsCompanyItaly.addClass( "form-input-hidden" );
			billingInputsCompanyItaly.removeClass( "form-input-visible" );
		}
		// billingInputsPrivateItaly.css("display", "none");
		billingInputsPrivateItaly.addClass( "form-input-hidden" );
		billingInputsPrivateItaly.removeClass( "form-input-visible" );
	} else {
		// billingInputsCompany.css("display", "none");
		billingInputsCompany.addClass( "form-input-hidden" );
		billingInputsCompany.removeClass( "form-input-visible" );
		// billingInputsCompanyItaly.css("display", "none");
		billingInputsCompanyItaly.addClass( "form-input-hidden" );
		billingInputsCompanyItaly.removeClass( "form-input-visible" );
		if( billingCountry == "IT" ){
			// billingInputsPrivateItaly.css("display", "block");
			billingInputsPrivateItaly.addClass( "form-input-visible" );
			billingInputsPrivateItaly.removeClass( "form-input-hidden" );
		} else {
			// billingInputsPrivateItaly.css("display", "none");
			billingInputsPrivateItaly.addClass( "form-input-hidden" );
			billingInputsPrivateItaly.removeClass( "form-input-visible" );
		}
	}

	switchInputsDisabled(
		$( ".woocommerce-checkout .woocommerce-billing-fields__field-wrapper" )
	);
}

function switchInputsDisabled( container ){
	const checkingFields = $( container ).find(
		".form-row:not(#billing_check_private_field)"
	);
	$( checkingFields ).each( ( _, field ) => {
		if( $( field ).css( "display" ) === "none" ){
			$( field ).find( "input" ).prop( "disabled", true );
		} else {
			$( field ).find( "input" ).prop( "disabled", false );
		}
	} );
}

function mobileFastLinks(){
	if( $( window ).width() < 576 ){
		if(
			$( ".navbar-nav .mobile-fast" ).length > 2 &&
			$( ".mobile-fast-links" ).length == 0
		){
			$( ".navbar-nav .mobile-fast" ).each( function( index ){
				if( index == 0 ){
					$( '<div class="mobile-fast-links container"></div>' ).appendTo(
						".mlc-header"
					);
				}
				if( index <= 3 ){
					$( this )
						.find( "> a" )
						.clone()
						.removeAttr( "class" )
						.appendTo( ".mobile-fast-links" );
				}
			} );
		}
	} else {
		if( $( ".mobile-fast-links" ).length > 0 ){
			$( ".mobile-fast-links" ).remove();
		}
	}
}

function loadMoreHandler(){
	let pageCount = 0;
	return function(){
		const btn = $( this );
		const ptCardContainer = btn.parents( ".mlc-pt-content" );
		const spinner = ptCardContainer.find( ".spinner" );
		const contentType = ptCardContainer.attr( "data-content" );
		const ptList = ptCardContainer.find( ".mlc-pt-cards" );
		const current_cat = ptCardContainer.data( 'cat_id' );
		const $search = $( 'input#search' ).val();
		let isPagesEnded = false;

		const sendAjax = new SendAjax( btn, "mlc_assets", contentType );

		if( current_cat ){
			loadData.current_cat = current_cat;
		}

		if( $search ){
			loadData.search = $search;
		}

		sendAjax.prepareSendData( loadData );

		sendAjax.beforeSend = () => {
			btn.prop( "disabled", true );
			spinner.removeClass( "hide" );
		};
		sendAjax.successSend = ( response ) => {

			const itemList = response.list.list;
			const isAuth = response.auth;

			itemList.forEach( ( item ) => {
				ptList.append( DownloadTemplates[ contentType ]( item, isAuth ) );
			} );

			if( pageCount === 0 ){
				pageCount = response.list.max_pages;
			}

			if( loadData.paged >= pageCount ){
				isPagesEnded = true;
				return;
			}

			loadData.paged = response.paged++;
		};
		sendAjax.complete = () => {
			spinner.addClass( "hide" );

			if( isPagesEnded ){
				btn.off( "click" );
				return;
			}
			btn.prop( "disabled", false );
		};

		sendAjax.send();
	};
}
